// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/CIUDAD_ENCANTADA_BACKGROUND.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Section-Infraestructura {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #e5e5e5;
  background-size: cover;
  background-position: center;
  min-height: 1000px;
  display: flex;
  justify-content: center;
}
.Section-Infraestructura .banderitaRoja {
  max-width: 110px;
  max-height: 149px;
  position: absolute;
  bottom: -50px;
  right: 20px;
  z-index: 9;
}
.Section-Infraestructura .infraimagen {
  position: relative;
}
.Section-Infraestructura .image {
  border-radius: 10px;
  width: 100%;
}
.Section-Infraestructura .gridgapcolumns1 {
  grid-gap: 40px;
}
.Section-Infraestructura .gridgapcolumns2 {
  grid-gap: 14px;
}
.Section-Infraestructura .gridgapcolumns3 {
  grid-gap: 15px;
}
.Section-Infraestructura #icon {
  max-width: 60px;
}
.Section-Infraestructura .title {
  margin: 0 20px 30px;
}
.Section-Infraestructura h2 {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 1rem;
  text-align: left;
  color: #333333;
}
.Section-Infraestructura h5 {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 130%;
  text-align: left;
  color: #4f4f4f;
  margin-top: 0px;
}
.Section-Infraestructura h4 {
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-size: 24px;
  line-height: 130%;
  color: #333333;
  margin: 0px;
}

@media screen and (max-width: 500px) and (min-width: 100px) {
  .Section-Infraestructura {
    padding: 20px 0 80px;
    min-height: 400px;
    height: 1230px;
  }
  .Section-Infraestructura .banderitaRoja {
    max-width: 80px;
  }
  .Section-Infraestructura h2 {
    font-size: 24px;
    font-weight: 600;
  }
  .Section-Infraestructura h5 {
    font-size: 18px;
  }
  .Section-Infraestructura h4 {
    font-size: 18px;
  }
  .Section-Infraestructura .padd {
    padding-bottom: 35px;
  }
  .Section-Infraestructura .gridgapcolumns1 {
    grid-gap: 0px;
  }
  .Section-Infraestructura .gridgapcolumns2 {
    grid-gap: 5px;
  }
  .Section-Infraestructura .gridgapcolumns3 {
    grid-gap: 18px;
  }
  .Section-Infraestructura #icon {
    min-width: 35px;
  }
}
@media screen and (max-width: 390px) and (min-width: 100px) {
  .Section-Infraestructura {
    padding: 20px 0 80px;
    min-height: 400px;
    height: 1330px;
  }
  .Section-Infraestructura #icon {
    min-width: 30px;
    margin-top: 5px;
  }
  .Section-Infraestructura .banderitaRoja {
    max-width: 60px;
    bottom: -40px;
  }
}
@media screen and (max-width: 1000px) and (min-width: 100px) {
  .Section-Infraestructura .banderitaRoja {
    max-width: 80px;
    bottom: -40px;
  }
  .Section-Infraestructura .title {
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .Section-Infraestructura .texttitle {
    text-align: center;
    margin: auto;
  }
  .Section-Infraestructura h2 {
    text-align: center;
  }
  .Section-Infraestructura h5 {
    text-align: center;
  }
}
@media screen and (max-width: 1350px) and (min-width: 100px) {
  .Section-Infraestructura .title {
    margin: 0 10px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Sections/Infraestructura/Infraestructura.scss"],"names":[],"mappings":"AAEA;EACE,yDAAA;EACA,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AADF;AAGE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;AAKE;EACE,mBAAA;EACA,WAAA;AAHJ;AAME;EACE,cAAA;AAJJ;AAOE;EACE,cAAA;AALJ;AAQE;EACE,cAAA;AANJ;AASE;EACE,eAAA;AAPJ;AAUE;EACE,mBAAA;AARJ;AAWE;EACE,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AATJ;AAYE;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAVJ;AAaE;EACE,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAXJ;;AAeA;EACE;IACE,oBAAA;IACA,iBAAA;IACA,cAAA;EAZF;EAcE;IACE,eAAA;EAZJ;EAeE;IACE,eAAA;IACA,gBAAA;EAbJ;EAgBE;IACE,eAAA;EAdJ;EAiBE;IACE,eAAA;EAfJ;EAkBE;IACE,oBAAA;EAhBJ;EAmBE;IACE,aAAA;EAjBJ;EAoBE;IACE,aAAA;EAlBJ;EAqBE;IACE,cAAA;EAnBJ;EAsBE;IACE,eAAA;EApBJ;AACF;AAwBA;EACE;IACE,oBAAA;IACA,iBAAA;IACA,cAAA;EAtBF;EAwBE;IACE,eAAA;IACA,eAAA;EAtBJ;EAyBE;IACE,eAAA;IACA,aAAA;EAvBJ;AACF;AA2BA;EAEI;IACE,eAAA;IACA,aAAA;EA1BJ;EA6BE;IACE,YAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;EA3BJ;EA8BE;IACE,kBAAA;IACA,YAAA;EA5BJ;EA+BE;IACE,kBAAA;EA7BJ;EAgCE;IACE,kBAAA;EA9BJ;AACF;AAkCA;EAEI;IACE,mBAAA;EAjCJ;AACF","sourcesContent":["@import \"~/src/utils/scss/index.scss\";\n\n.Section-Infraestructura {\n  background-image: url($Infraestructura_Background);\n  background-color: #e5e5e5;\n  background-size: cover;\n  background-position: center;\n  min-height: 1000px;\n  display: flex;\n  justify-content: center;\n\n  .banderitaRoja {\n    max-width: 110px;\n    max-height: 149px;\n    position: absolute;\n    bottom: -50px;\n    right: 20px;\n    z-index: 9;\n  }\n\n  .infraimagen {\n    position: relative;\n  }\n\n  .image {\n    border-radius: 10px;\n    width: 100%;\n  }\n\n  .gridgapcolumns1 {\n    grid-gap: 40px;\n  }\n\n  .gridgapcolumns2 {\n    grid-gap: 14px;\n  }\n\n  .gridgapcolumns3 {\n    grid-gap: 15px;\n  }\n\n  #icon {\n    max-width: 60px;\n  }\n\n  .title {\n    margin: 0 20px 30px;\n  }\n\n  h2 {\n    font-family: \"Montserrat\", sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 48px;\n    line-height: 1rem;\n    text-align: left;\n    color: #333333;\n  }\n\n  h5 {\n    font-family: \"Roboto\", sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 22px;\n    line-height: 130%;\n    text-align: left;\n    color: #4f4f4f;\n    margin-top: 0px;\n  }\n\n  h4 {\n    font-weight: 600;\n    font-family: \"Montserrat\", sans-serif;\n    font-style: normal;\n    font-size: 24px;\n    line-height: 130%;\n    color: #333333;\n    margin: 0px;\n  }\n}\n\n@media screen and (max-width: 500px) and (min-width: 100px) {\n  .Section-Infraestructura {\n    padding: 20px 0 80px;\n    min-height: 400px;\n    height: 1230px;\n\n    .banderitaRoja {\n      max-width: 80px;\n    }\n\n    h2 {\n      font-size: 24px;\n      font-weight: 600;\n    }\n\n    h5 {\n      font-size: 18px;\n    }\n\n    h4 {\n      font-size: 18px;\n    }\n\n    .padd {\n      padding-bottom: 35px;\n    }\n\n    .gridgapcolumns1 {\n      grid-gap: 0px;\n    }\n\n    .gridgapcolumns2 {\n      grid-gap: 5px;\n    }\n\n    .gridgapcolumns3 {\n      grid-gap: 18px;\n    }\n\n    #icon {\n      min-width: 35px;\n    }\n  }\n}\n\n@media screen and (max-width: 390px) and (min-width: 100px) {\n  .Section-Infraestructura {\n    padding: 20px 0 80px;\n    min-height: 400px;\n    height: 1330px;\n\n    #icon {\n      min-width: 30px;\n      margin-top: 5px;\n    }\n\n    .banderitaRoja {\n      max-width: 60px;\n      bottom: -40px;\n    }\n  }\n}\n\n@media screen and (max-width: 1000px) and (min-width: 100px) {\n  .Section-Infraestructura {\n    .banderitaRoja {\n      max-width: 80px;\n      bottom: -40px;\n    }\n\n    .title {\n      margin: auto;\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n    }\n\n    .texttitle {\n      text-align: center;\n      margin: auto;\n    }\n\n    h2 {\n      text-align: center;\n    }\n\n    h5 {\n      text-align: center;\n    }\n  }\n}\n\n@media screen and (max-width: 1350px) and (min-width: 100px) {\n  .Section-Infraestructura {\n    .title {\n      margin: 0 10px 10px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
